import React from 'react';
import { Check } from 'lucide-react';

/** ✓ (green) when linked, — (gray) when not. */
const LinkedFlag: React.FC<{ linked: boolean; title: string }> = ({ linked, title }) =>
  linked ? (
    <Check className="w-4 h-4 text-green-600" aria-label={title} />
  ) : (
    <span className="text-xs text-gray-400" aria-label={title}>
      —
    </span>
  );

export default LinkedFlag;
